import {
  Formfield,
  FormfieldProps,
} from '@designsystem/stories/03-molecules/Formfield';
import Radio from '../Radio/Radio';

export interface RadioGroupProps extends FormfieldProps {
  id?: string;
  name?: string;
  value?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  onChange?: (value: string) => void;
  options: Array<Array<string>>;
}

const RadioGroup = ({
  id,
  name,
  value,
  label,
  labelRequired,
  description,
  errorMessage,
  isRequired = false,
  isInvalid,
  isDisabled,
  onChange,
  children,
  options,
  ...props
}: RadioGroupProps) => {
  return (
    <Formfield
      label={label}
      description={description}
      isRequired={isRequired}
      labelRequired={labelRequired}
      errorMessage={errorMessage}
    >
      <ul className="unstyled">
        {options.map((option: Array<string>, i: number) => (
          <Radio
            key={i}
            name={id}
            value={option[0]}
            label={option[1]}
            selected={option[0] === value}
            error={isInvalid}
            onChange={(selected: boolean) => {
              if (onChange && selected) {
                onChange(option[0]);
              }
            }}
          />
        ))}
      </ul>
    </Formfield>
  );
};

export default RadioGroup;
